import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/core/components/ui/card";
import { cn } from "@/core/lib/utils";

interface DashboardCardProps {
  title: string | React.ReactNode;
  children: React.ReactNode;
  className?: string;
  headerIcon?: React.ReactNode;
  centerContent?: boolean;
}

export function DashboardCard({
  title,
  children,
  className,
  headerIcon,
  centerContent = false,
}: DashboardCardProps) {
  return (
    <Card className={cn("h-full w-full", className)}>
      <CardHeader className="flex border-b border-light-gray-400 px-3 py-4 h-14">
        <CardTitle className="text-base font-normal">{title}</CardTitle>
        {headerIcon}
      </CardHeader>
      <CardContent
        className={cn(
          "h-[calc(100%-3.5rem)] p-0 px-0 py-6",
          centerContent && "flex items-center justify-center",
        )}
      >
        {children}
      </CardContent>
    </Card>
  );
}
